import { Dispatch, SetStateAction } from 'react';
import { GRID_DATA_LIMIT } from '../../constants';

export const setDatasetFetchState = (
  offset: number,
  lazy: boolean,
  setOffset: Dispatch<SetStateAction<number>>,
  setDisabledLazyLoading: Dispatch<SetStateAction<boolean>>,
  customLimit?: number
) => {
  if (lazy) {
    setOffset(offset);
  } else {
    // After custom-limit fetch (e.g. 1550 rows for locate-by-id), seed offset
    // so next lazy load continues from customLimit (offsetRef + GRID_DATA_LIMIT).
    setOffset(customLimit ? customLimit - GRID_DATA_LIMIT : 0);
    setDisabledLazyLoading(false);
  }
};
